import { ExchangeCodePayload } from "../models/Sso";
import API from "./api";

export const GetExchangedToken = (configUrl: string, payload: ExchangeCodePayload) =>
  API.postApi(`${configUrl}api/Sso/ExchangeCodeForToken`, payload, true);

export const GetRefreshToken = (configUrl: string, payload: any) =>
  API.postApi(`${configUrl}api/Sso/RefreshToken`, payload , true);
